export const isAdmin = (access) => access.length > 0;

export const isOwner = (access) =>
  access.filter((admin) => admin.level === 1).length > 0;



// WEBPACK FOOTER //
// ./src/utils/adminCheck.js